import React from 'react';
import { Button } from '@mui/material';
import { PiDetectiveFill } from "react-icons/pi";
import { ThemeProvider, createTheme } from '@mui/material';
import CompanyName from '../Component/CompanyName';
import CustomSolutionsforEveryNeedImage from '../Images/CustomSolutionsforEveryNeed.webp';
import WideTemperatureResistanceImage from '../Images/WideTemperatureResistance.webp';
import ExceptionalAdhesionDurabilityImage from '../Images/ExceptionalAdhesionDurability.webp';
import ColorsFinishesThatImpressImage from '../Images/ColorsFinishesThatImpress.webp';
import TryBeforeYouCommitImage from '../Images/TryBeforeYouCommit.webp';
import HotStampPrintingwowImage from '../Images/HotStampPrintingwow.webp'

const theme = createTheme({
    palette: {
        primary: {
            main: "#F61832", // custom primary color
        },
        secondary: {
            main: "#C13E39", // custom secondary color
        },
    },
});

const HotStampPrinting = () => {
  return (
    <>
    <title>Hot Stamp Printing</title>
    <article className='pt-8 max-w-[1200px] mx-auto px-8'>


      <header className="mb-4 ">
        <h1 className="text-3xl font-bold mb-4">Hot Stamp Printing</h1>
        <p className="text-lg">
          Advantages of Hot Stamp Printing
        </p>
      </header>

  <section class="p-4 ">
    <div class="">
      <h2 class="text-2xl  font-bold mb-8 text-center">Why Choose <CompanyName/> Foils?</h2>

      <div className='lg:flex lg:gap-8'>
       <div className="lg:w-1/3">
       
            <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-white/15 hover:-translate-y-2 hover:shadow-2xl cursor-pointer group"
              >
              {/* Service Image */}
              <div className="relative overflow-hidden">
                <img
                  src={ExceptionalAdhesionDurabilityImage}
                  alt=""
                  className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
              </div>

              {/* Service Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold  mb-3">
                  Exceptional Adhesion & Durability
                </h3>
                <p className="leading-relaxed mb-6">
                              Our foils are engineered for <strong>rough, dry, and non-porous surfaces</strong>, maintaining high brightness and gloss in all applications. They resist peeling and fading, ensuring your prints stay vibrant for longer.

                </p>


              </div>
            </div>

        </div>


        <div className="lg:w-1/3">
       
            <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-white/15 hover:-translate-y-2 hover:shadow-2xl cursor-pointer group"
              >
              {/* Service Image */}
              <div className="relative overflow-hidden">
                <img
                  src={WideTemperatureResistanceImage}
                  alt=""
                  className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
              </div>

              {/* Service Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold  mb-3">
                  Wide Temperature Resistance
                </h3>
                <p className="leading-relaxed mb-6">
            Withstand extreme conditions—our foils perform flawlessly in temperatures ranging from <strong>0°C to 220°C</strong>, making them ideal for industrial, automotive, and food packaging applications.

                </p>


              </div>
            </div>

        </div>

       <div className="lg:w-1/3">
       
            <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-white/15 hover:-translate-y-2 hover:shadow-2xl cursor-pointer group"
              >
              {/* Service Image */}
              <div className="relative overflow-hidden">
                <img
                  src={CustomSolutionsforEveryNeedImage}
                  alt=""
                  className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
              </div>

              {/* Service Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold  mb-3">
                  Custom Solutions for Every Need
                </h3>
                <p className="leading-relaxed mb-6">
                Need a foil that resists <strong>frost, humidity, UV rays, or chemicals</strong>? Our experts will guide you in selecting the perfect grade to meet your project's demands.
                </p>


              </div>
            </div>

        </div>

</div>
      
    </div>
  </section>


  <section class="">
    <div class="mx-auto">
      <div className='lg:float-left ml-4 mr-8 mb-4 lg:w-2/12'><img src={ColorsFinishesThatImpressImage} alt='' title='' className='rounded-br-3xl'/></div>
      <h2 class="text-2xl font-bold mb-6">Colors & Finishes That Impress</h2>
      <p class=" mb-6">
        Beyond standard and custom colors, we offer:
      </p>
      <ul class="list-disc pl-6 space-y-3 ">
        <li><strong>Metallic foils</strong> in gold, silver, and other lustrous shades</li>
        <li><strong>Gloss & satin finishes</strong> for a premium look and feel</li>
        <li><strong>UV watermarks & anti-counterfeiting marks</strong> to protect your brand</li>
      </ul>
    </div>
  </section>


  <section class="clear-both">
    <div class="">
      <div className='lg:float-right ml-8 mb-4 lg:w-2/12'><img src={TryBeforeYouCommitImage} alt='' title='' className='rounded-tl-3xl'/></div>
      <div class="">
        <h2 class="text-2xl font-bold my-4">Try Before You Commit</h2>
        <p class=" mb-4">
          We understand that quality matters—that's why we offer:
        </p>
        <ul class="list-disc pl-6 space-y-3 ">
          <li><strong>Free sample prints</strong> on your products so you can see the results firsthand</li>
          <li><strong>Sample roll orders</strong> for testing in your production line</li>
        </ul>
      </div>

      <div>
        <h2 class="text-2xl font-bold my-4">Certified Quality You Can Trust</h2>
        <p class="">
          We supply foils to <strong>food, pharmaceutical, and other regulated industries</strong>. Need certifications? We provide full documentation to meet your compliance requirements.
        </p>
      </div>
    </div>
  </section>

 

    </article>

     <section>
  <img src={HotStampPrintingwowImage} alt='' title=''/>
  </section>


  <section class="text-center pt-8 max-w-[1200px] mx-auto">
    <div class="max-w-3xl mx-auto">
      <h2 class="text-2xl  font-bold mb-6">Ready to Elevate Your Printing?</h2>
      <p class="text-lg mb-8">
        Whether you need a custom foil solution or expert advice, <strong><CompanyName/></strong> is your trusted partner. Contact us today to discuss your project!
      </p>


<div>
            <ThemeProvider theme={theme}>
              <Button color="primary" variant="contained" size="large" fullWidth endIcon={<PiDetectiveFill/>} href='/Contact'>
                Get a Free Consultation
              </Button>
            </ThemeProvider>
</div>


      <a href="/Contact" class="inline-block  text-blue-600 font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition duration-300">
        
      </a>
    </div>
  </section>
    </>
  )
}

export default HotStampPrinting
